
  import { defineComponent } from 'vue';
  import { Button } from '@/ui/components/Button';
  import { Icon } from '@/ui/components/icon/Icon';

  export default defineComponent({
    name: 'CollapseAllButton',
    components: {
      Button,
      Icon,
    },
    props: {
      collapseAllFn: {
        type: Function,
        required: true,
      },
      expandAllFn: {
        type: Function,
        required: true,
      },
    },
    methods: {
      handleCollapseAll() {
        this.collapseAllFn();
      },
      handleExpandAll() {
        this.expandAllFn();
      },
    },
  });
